// extracted by mini-css-extract-plugin
export default {"arrowUp":"RankDiff_arrowUp__5hC2y","arrowDown":"RankDiff_arrowDown__p6B5B","rankDiffValue":"RankDiff_rankDiffValue__iY-Lc","value":"RankDiff_value__bp2EO"};